import {
  Typography,
  TextField,
  Paper,
  Button,
} from '@mui/material';

interface InfoProps {
  title: string,
  lastVal: string | undefined,
  onChange: (arg: string) => void,
  error: string | undefined,
  fy?: boolean,
  na?: boolean,
  required?: boolean
}

export function InfoBox({
  title, lastVal, onChange, error, fy = false, na = false, required = true
}: InfoProps) {
  if (lastVal === undefined) lastVal = '';
  return <>
    <Paper
        sx={{
        bgcolor: 'info.main',
        borderRadius: 1,
        px: 3,
        py: 2,
        display: 'flex',
        flexDirection: 'column',
        textTransform: 'uppercase',
        flex: 1
        }}
    >
        <Typography variant={'subtitle2'} sx={{ fontSize: 10, mb: 3, color: 'primary.main' }}>
        {title}
        {required && ' *'}
        </Typography>
        <TextField
        value={fy ? "FY " + lastVal : lastVal}
        onChange={(e) => onChange(fy ? e.target.value.replace("FY ", "").replace("FY", "") : e.target.value)}
        fullWidth
        required={required}
        error={!!error}
        helperText={error}
        autoFocus
        variant='standard'
        sx={{
            '& .MuiInputBase-input': { color: 'primary.main' },
        }}
        />
        {na && (
        <Button
          variant='contained'
          color='success'
          size="small"
          onClick={() => onChange('')}
          sx={{
            fontSize: '0.65rem',
            backgroundColor: 'info.light',
            py: 0.5,
            px: 1,
            alignSelf: 'center',
            minWidth: 'auto',
            borderRadius: 0.5,
            mt: 3,
          }}
        >
          Not Applicable
        </Button>
      )}
    </Paper>
  </>;
}
